import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit';

import { errorNotification } from '../../components/notifications';
import api from '../../libs/api';

const initialState = {
  tdsmasters: [],
  tdsmaster: {},
  tdsmasterIds: [],
};

export const getTdsMasters = createAsyncThunk(
  'tdsmasters/getTdsMasters',
  async () => {
    const { data } = await api.get('/accounts/tdsmasters');

    return data;
  },
);

export const getTdsMasterIds = createAsyncThunk(
  'tdsmasters/getTdsMasterIds',
  async () => {
    const { data } = await api.get('/accounts/tdsmasters/ids');

    return data;
  },
);

export const getTdsMaster = createAsyncThunk(
  'tdsmasters/getTdsMaster',
  async id => {
    const { data } = await api.get(`/accounts/tdsmasters/${id}`);

    return data;
  },
);

export const addTdsMaster = createAsyncThunk(
  'tdsmasters/addTdsMaster',
  async data => {
    const { data: tdsmaster } = await api.post('/accounts/tdsmasters', data);

    return tdsmaster;
  },
);

export const editTdsMaster = createAsyncThunk(
  'tdsmasters/editTdsMaster',
  async ({ id, data }) => {
    const { data: tdsmaster } = await api.put(
      `/accounts/tdsmasters/${id}`,
      data,
    );

    return tdsmaster;
  },
);

const tdsmasters = createSlice({
  name: 'tdsmasters',

  initialState,

  reducers: {
    clearTdsMasters: draft => {
      draft.tdsmasters = initialState.tdsmasters;
    },

    clearTdsMaster: draft => {
      draft.tdsmaster = initialState.tdsmaster;
    },

    clearTdsMasterIds: draft => {
      draft.tdsmasterIds = initialState.tdsmasterIds;
    },
  },

  extraReducers: builder => {
    builder.addCase(getTdsMasters.fulfilled, (draft, { payload }) => {
      draft.tdsmasters = payload;
    });

    builder.addCase(getTdsMaster.fulfilled, (draft, { payload }) => {
      draft.tdsmaster = payload;
    });

    builder.addCase(addTdsMaster.fulfilled, (draft, { payload }) => {
      draft.tdsmasters.push(payload);
    });

    builder.addCase(editTdsMaster.fulfilled, (draft, { payload }) => {
      const index = draft.tdsmasters.findIndex(el => el.id === payload.id);

      draft.tdsmasters[index] = payload;
    });

    builder.addCase(getTdsMasterIds.fulfilled, (draft, { payload }) => {
      draft.tdsmasterIds = payload;
    });

    builder.addMatcher(
      isAnyOf(
        getTdsMasters.rejected,
        getTdsMaster.rejected,
        addTdsMaster.rejected,
        editTdsMaster.rejected,
        getTdsMasterIds.rejected,
      ),
      (_Draft, { error }) => {
        errorNotification(error);
      },
    );
  },
});

export const { clearTdsMasters, clearTdsMaster, clearTdsMasterIds } =
  tdsmasters.actions;

export default tdsmasters.reducer;
